// src/index.js
import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./App.css";
import { ThemeProvider } from "./util/ThemeContext";
import { App as AntdApp } from "antd";
import { PreferenceProvider } from "./context/PreferenceContext";
import { LocationProvider, LocationContext } from "./LocationContext";
import { WishlistProvider } from "./WishlistContext";
import { CartProvider } from "./CartContext";
import { DeliveryEstimateProvider } from "./context/DeliveryEstimateContext";
import { CategoryProvider } from "./context/CategoryContext";

// Thin wrapper: reads lat/lng from LocationContext and provides delivery estimates app-wide
const AppWithDelivery = () => {
  const { latitude, longitude } = useContext(LocationContext);
  return (
    <DeliveryEstimateProvider latitude={latitude} longitude={longitude}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </DeliveryEstimateProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AntdApp notification={{ maxCount: 1, placement: "topCenter" }}>
      <PreferenceProvider>
        <LocationProvider>
          <WishlistProvider>
            <CartProvider>
              <CategoryProvider>
                <AppWithDelivery />
              </CategoryProvider>
            </CartProvider>
          </WishlistProvider>
        </LocationProvider>
      </PreferenceProvider>
    </AntdApp>
  </BrowserRouter>
);
